import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoDiners24 = t0 => {
  const $ = _c(7);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M13.545 19.1952C17.4425 19.214 21 15.9873 21 12.0622C21 7.77018 17.4425 4.80309 13.545 4.80469H10.1906C6.24666 4.80309 3 7.77098 3 12.0622C3 15.9882 6.24666 19.214 10.1906 19.1952H13.545Z" fill="#0079BE" />;
    t2 = <path d="M10.2064 5.39954C6.60209 5.40074 3.68187 8.3486 3.68066 11.987C3.68187 15.6249 6.60209 18.5728 10.2064 18.574C13.8111 18.5728 16.7326 15.6249 16.733 11.987C16.7326 8.3486 13.8115 5.40074 10.2064 5.39954ZM6.0702 11.987C6.06944 11.1457 6.32247 10.3239 6.79623 9.62873C7.26999 8.9336 7.94244 8.39756 8.72568 8.09066V15.8829C7.94237 15.5762 7.26985 15.0403 6.79607 14.3452C6.32228 13.6501 6.0693 12.8282 6.0702 11.987ZM11.6868 15.8845V8.09026C12.4706 8.39672 13.1436 8.93272 13.6177 9.62808C14.0918 10.3234 14.3449 11.1458 14.3438 11.9874C14.3447 12.8289 14.0916 13.6512 13.6175 14.3465C13.1434 15.0419 12.4705 15.5779 11.6868 15.8845Z" fill="#fff" />;
    t3 = <path d="M13.545 19.1952C17.4425 19.214 21 15.9873 21 12.0622C21 7.77018 17.4425 4.80309 13.545 4.80469H10.1906C6.24666 4.80309 3 7.77098 3 12.0622C3 15.9882 6.24666 19.214 10.1906 19.1952H13.545Z" fill="#0079BE" />;
    t4 = <path d="M10.2064 5.39954C6.60209 5.40074 3.68187 8.3486 3.68066 11.987C3.68187 15.6249 6.60209 18.5728 10.2064 18.574C13.8111 18.5728 16.7326 15.6249 16.733 11.987C16.7326 8.3486 13.8115 5.40074 10.2064 5.39954ZM6.0702 11.987C6.06944 11.1457 6.32247 10.3239 6.79623 9.62873C7.26999 8.9336 7.94244 8.39756 8.72568 8.09066V15.8829C7.94237 15.5762 7.26985 15.0403 6.79607 14.3452C6.32228 13.6501 6.0693 12.8282 6.0702 11.987ZM11.6868 15.8845V8.09026C12.4706 8.39672 13.1436 8.93272 13.6177 9.62808C14.0918 10.3234 14.3449 11.1458 14.3438 11.9874C14.3447 12.8289 14.0916 13.6512 13.6175 14.3465C13.1434 15.0419 12.4705 15.5779 11.6868 15.8845Z" fill="#fff" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== ariaLabel || $[5] !== className) {
    t5 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}{t3}{t4}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default IcoDiners24;